

import { SubDomain } from "../SubDomain";
import Answer from "./Answer.js";

export default class AnswersDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, Answer.MODEL_NAME);
    this.storage = storage;
  }

  list() {
    return this.storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new Answer(this.domain, item);
      }
    }

    return new Answer(this.domain);
  }
  
    
}